import { Component, OnInit, Input, Output, ViewChild, ViewEncapsulation, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment/moment';

import { MatSidenav, MatDialog } from '@angular/material';
import { UserIdleService, UserIdleModule } from 'angular-user-idle';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit {

    constructor() { }

    ngOnInit() { }

   
}




// WEBPACK FOOTER //
// ./SignClient/app/app.component.ts